// extracted by mini-css-extract-plugin
export default {"messageMargin":"MessageBars_messageMargin__FaaAl"};